__turbopack_context__.v({
  "errorMessage": "_7l8dkG_errorMessage",
  "priceDetails": "_7l8dkG_priceDetails",
});
